import React, { FormEvent, FormEventHandler } from 'react';

import SidebarModal, { SidebarModalProps } from './SidebarModal';
import SidebarModalActionFooter from './SidebarModalActionFooter';

export interface SidebarModalFormProps extends SidebarModalProps {
  actionTitle: string;
  cancelTitle?: string;
  hideFooterActions?: boolean;
  isSubmitting: boolean;
  isDisabled?: boolean;
  onSubmit: FormEventHandler;
  isEqualWidth?: boolean;
}

const SidebarModalForm: React.FC<SidebarModalFormProps> = ({
  hideFooterActions: hideFooterAction = false,
  children,
  actionTitle,
  cancelTitle = 'Cancel',
  isSubmitting,
  isDisabled,
  onSubmit,
  isEqualWidth = false,
  ...props
}) => {
  const handleSubmit = (evt: FormEvent) => {
    evt.preventDefault();
    onSubmit(evt);
  };

  return (
    <SidebarModal {...props}>
      <form
        className='flex flex-col justify-between min-h-full'
        onSubmit={handleSubmit}
        title='sidebar-form'
      >
        <div className='p-4 flex-auto mb-20'>{children}</div>
        {!hideFooterAction && (
          <SidebarModalActionFooter
            submitButtonText={actionTitle}
            cancelButtonText={cancelTitle}
            onClose={props?.onClose}
            isSubmitting={isSubmitting}
            isDisabled={isSubmitting || isDisabled}
            isEqualWidth={isEqualWidth}
          />
        )}
      </form>
    </SidebarModal>
  );
};

export default SidebarModalForm;
